import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import exportFacade from "./exportFacade";

export default {
  DoExportQuotation(_input) {
    let input = exportFacade.GetQuotationReportParameter(_input);

    return API.peakReportAPI
      .post("/api/EmailReport/ExportQuotation", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportInvoice(_input) {
    let input = exportFacade.GetInvoiceReportParameterModel(_input);

    return API.peakReportAPI.post("/api/EmailReport/ExportInvoice", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoExportReceipt(_input) {
    let input = exportFacade.GetReceiptReportParameterModel(_input);

    return API.peakReportAPI.post("/api/EmailReport/ExportReceipt", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoExportTaxInvoice(_input) {
    let input = exportFacade.GetTaxInvoiceReportParameterModel(_input);

    return API.peakReportAPI
      .post("/api/EmailReport/ExportTaxInvoice", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportCreditNote(_input) {
    let input = exportFacade.GetCreditNoteReportParameterModel(_input);

    return API.peakReportAPI
      .post("/api/EmailReport/ExportCreditNote", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportDebitNote(_input) {
    let input = exportFacade.GetDebitNoteReportParameterModel(_input);

    return API.peakReportAPI
      .post("/api/EmailReport/ExportDebitNote", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportBillingNote(_input) {
    let input = exportFacade.GetBillingNoteReportParameterModel(_input);

    return API.peakReportAPI
      .post("/api/EmailReport/ExportBillingNote", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportChartOfAccount(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      chartOfAccountReportType: _input.chartOfAccountReportType,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };

    return API.peakReportAPI
      .post("/api/EmailReport/ExportChartOfAccount", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportDailyJournal(_input) {
    let input = exportFacade.GetJournalReportParameterModel(_input);
    return API.peakReportAPI
      .post("/api/EmailReport/ExportDailyJournal", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportAging(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      financeType: _input.financeTypeId,
      reportCriteriaModel: _input.reportCriteria,
      contactGroupId: _input.contactGroupId,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
      isShowArchivedContact: _input.isShowArchivedContact,
    };
    return API.peakReportAPI.post("/api/EmailReport/ExportAging", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoExportContact(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      reportCriteriaModel: _input.reportCriteria,
      contactGroupId: _input.contactGroupId,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
      isShowArchivedContact: _input.isShowArchivedContact,
      contactTableViewStatusType: _input.contactTableViewStatusType,
      contactFinanceType: _input.contactFinanceType,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportContactTemplate", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportWht(_input) {
    let exportWhtPath = "";
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      orderText: _input.orderText,
      searchText: _input.searchText,
      whtTableViewStatus: _input.whtTableViewStatus,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };
    if (_input.paymentInOutFlowType === Enums.PaymentInOutFlowType.CashIn) {
      exportWhtPath = "ExportWitheldTax";
    } else {
      exportWhtPath = "ExportWitholdingTax";
    }
    return API.peakReportAPI
      .post("/api/EmailReport/" + exportWhtPath, input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportWhtExportWitholdingTaxByPndType(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      filingDate: _input.filingDate,
      pndType: _input.pndType,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      isIncomeTaxTypeShortly: _input.isIncomeTaxTypeShortly,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportWitholdingTaxByPndType", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportFinance(_input) {
    let input = {
      data: {
        merchantId: userInfo.MerchantId(),
        timezoneOffset: userInfo.GetTimezoneOffset(),
        bankAccountId: _input.bankAccountId,
        fromDate: _input.fromDate,
        toDate: _input.toDate,
        isOrderPaymentDateAsc: _input.isOrderPaymentDateAsc,
        pageTypeId: _input.pageTypeId,
        isSendEmail: _input.isSendEmail,
        fromEmail: _input.fromEmail,
        receiveEmailList: _input.receiveEmailList,
        accountId: _input.accountId,
        language: i18n.locale,
        searchText: _input.searchText,
        orderBy: _input.orderBy,
        sortType: _input.sortType,
        filterReconcile: _input.filterReconcile,
      },
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportFinanceForNewPeak", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  ExportProductTemplate(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      productTemplateType: _input.productTemplateType,
      isShowAccount: _input.isShowAccount,
      isProductHaveMovement: _input.isProductHaveMovement,
      isShowRemainGL: _input.isShowRemainGL,
      isShowStandardPrice: _input.isShowStandardPrice,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportProductTemplate", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  ExportUnit(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
      unitTypeId: _input.unitTypeId,
      isDeleted: _input.isDeleted,
      isProductAndService: _input.isProductAndService,
    };
    return API.peakReportAPI.post("/api/EmailReport/ExportUnit", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  ExportTrialBalance(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      reportCriteria: _input.reportCriteria,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportTrialBalance", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportProfitLoss(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      reportCriteria: _input.reportCriteria,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportProfitLoss", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportCashFlowStatement(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      reportCriteria: _input.reportCriteria,
      isSendEmail: _input.isSendEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportCashFlowStatement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportBalanceSheet(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      reportCriteria: _input.reportCriteria,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportBalanceSheet", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportStatementEFilingXBRLByEFilingId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      eFilingId: input.eFilingId,
      language: i18n.locale,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
    };

    return API.peakReportAPI
      .post("/api/EmailReport/ExportStatementEFilingXBRLByEFilingId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportStatementEFilingExcelByEFilingId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      eFilingId: input.eFilingId,
      language: i18n.locale,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
    };

    return API.peakReportAPI
      .post("/api/EmailReport/ExportStatementEFilingExcelByEFilingId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoExportCheque(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      paymentInOutFlowType: _input.paymentInOutFlowType,
      orderText: _input.orderText,
      searchText: _input.searchText,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      language: i18n.locale,
    };

    return API.peakReportAPI
      .post("/api/EmailReport/ExportChequeReport", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  ExportStockCardMovement(_input) {
    let input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      fromDate: _input.fromDate,
      toDate: _input.toDate,
      isSendEmail: _input.isSendEmail,
      fromEmail: _input.fromEmail,
      receiveEmailList: _input.receiveEmailList,
      productTemplateId: _input.productTemplateId,
      language: i18n.locale,
      reportCriteriaModel: _input.reportCriteria,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportStockCardMovement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
